import { useNavigate } from 'react-router';
import Paths from '@/configs/router/paths.ts';

export default function useChatActive(chatId: string) {
  const navigate = useNavigate();
  return useCallback(() => {
    navigate(Paths.MESSAGES_CHATS + '/' + chatId);
  }, [navigate, chatId]);
}
